export var ToastType;
(function (ToastType) {
    ToastType["INFORMATION"] = "INFORMATION";
    ToastType["POSITIVE"] = "POSITIVE";
    ToastType["WARNING"] = "WARNING";
    ToastType["ERROR"] = "ERROR";
})(ToastType || (ToastType = {}));
//# sourceMappingURL=CsToast.js.map